import js from '../images/icons/js-logo.webp';
import react from '../images/icons/react.png';
import css from '../images/icons/css.png';
import html from '../images/icons/html.png';
import git from '../images/icons/git.png';
import github from '../images/icons/github.png';
import python from '../images/icons/python.png';
import vsc from '../images/icons/vsc.svg';
import tosca from '../images/icons/tosca.png';
import cypress from '../images/icons/cypress.jpg';
import istqb from "./istqb.pdf";
import kiwi from "./kiwi.pdf";


export const skillList = [
    {
        skill: 'JavaScript',
        level: '',
        logo: js
    },
    {
        skill: 'React',
        level: '',
        logo: react
    },
    {
        skill: 'Python',
        level: '',
        logo: python
    },
    {
        skill: 'HTML',
        level: '',
        logo: html
    },
    {
        skill: 'CSS',
        level: '',
        logo: css
    },
    {
        skill: 'VS Code',
        level: '',
        logo: vsc
    },
    {
        skill: 'Cypress',
        level: '',
        logo: cypress
    },
    {
        skill: 'GitHub',
        level: '',
        logo: github
    },
    {
        skill: 'Git',
        level: '',
        logo: git
    },
    {
        skill: 'Tosca',
        level: '',
        logo: tosca
    }
];

export const certifications = [
 {
    name: "ISTQB Certified Tester Foundation Level",
    link: istqb
 },
 {
    name: "Automation Specialist for API",
    link: "https://verify.skilljar.com/c/wau3c5k2cwuj"
 },
 {
    name: "Test Architect Level 1",
    link: "https://verify.skilljar.com/c/i9rrnkt2iynz"
 },
 {
    name: "Kiwi Cypress Weekend participation (hackaton)",
    link: kiwi
 },
];